import { useRef, memo } from 'react';
import { useParams } from 'react-router-dom';
import { Typography } from 'antd';
import ReactECharts from 'echarts-for-react';
import { useGetMetricsQuery } from '@/redux';
import { ColumnTypesEnum } from '@/core';
import { getOptionsProductsChart } from './helpers';
import { useGetMaxQuantityShownColumns } from './hooks/useGetMaxQuantityShownColumns';
import { EmptyChart } from './EmptyChart';
import { DownloadChartBtn } from './DownloadChartBtn';
import classes from './ProductsChart.module.scss';

type ProductsChartPropsType = {
  startDate?: string;
  endDate?: string;
};

const useGetProductsChartData = ({ startDate, endDate }: ProductsChartPropsType) => {
  const maxShownColumns = useGetMaxQuantityShownColumns();
  const isRequestSkipped = !startDate || !endDate;
  const { id } = useParams();

  const { data: metricsData } = useGetMetricsQuery(
    { id: id!, startDate, endDate, type: ColumnTypesEnum.Product },
    { skip: isRequestSkipped },
  );
  const { options, isChartExpanded } = getOptionsProductsChart(maxShownColumns, metricsData) ?? {};

  return { options, isChartExpanded };
};

const ProductsChart = (props: ProductsChartPropsType) => {
  const chartRef = useRef<ReactECharts | null>(null);
  const { options, isChartExpanded } = useGetProductsChartData(props);

  return (
    <>
      {options?.series?.length ? (
        <div className={classes.productsChartWrapper}>
          <div className={classes.productsChartPanel}>
            <div className={classes.titleWrapper}>
              <Typography.Title level={3} className="mb-0">
                Products Distribution
              </Typography.Title>
              <DownloadChartBtn chartRef={chartRef} fileName="Products.pdf" />
            </div>
          </div>
          <ReactECharts
            style={{ height: isChartExpanded ? 400 : 345 }}
            ref={chartRef}
            className={classes.productsChart}
            option={options}
            notMerge={true}
          />
        </div>
      ) : (
        <EmptyChart title="Products" />
      )}
    </>
  );
};

export default memo(ProductsChart);
